"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question:
      "What manufacturing services are integrated at MMI under one roof?",
    answer:
      "MMI integrates metal casting, machining, forging, plastic and rubber molding, powder coating, plating, CMM inspection, and sub-assembly within a single facility to reduce lead time and supplier handoffs.",
  },
  {
    question:
      "What casting processes does MMI support for industrial components?",
    answer:
      "MMI supports lost foam casting for complex geometries along with casting programs across aluminium alloys, non-ferrous alloys, cast iron and ductile iron, steel, and stainless steel components.",
  },
  {
    question:
      "How does MMI handle complex geometries and near-net-shape components?",
    answer:
      "MMI uses lost foam casting combined with controlled process planning to manufacture complex, near-net-shape components with consistent wall thickness and reduced secondary operations.",
  },
  {
    question:
      "What quality assurance and inspection systems are followed at MMI?",
    answer:
      "Quality assurance at MMI is managed through defined quality systems, ISO 9001 certification, and PPAP implementation. Dimensional verification is performed using CMM inspection, along with in-process and final inspections to ensure compliance with customer drawings and specifications.",
  },
  {
    question: "What finishing and value-added services does MMI provide?",
    answer:
      "MMI provides powder coating and plating services including zinc, nickel, and nickel-chrome plating to support corrosion protection, surface durability, and functional performance.",
  },
  {
    question:
      "Which industries does MMI serve with its manufacturing capabilities?",
    answer:
      "MMI serves electrical power equipment, oil and gas equipment, commercial and off-highway vehicles, construction and agricultural equipment, mining equipment, consumer appliances, pumps and compressors, and hardware and fasteners.",
  },
  {
    question: "Can MMI support prototype to production manufacturing programs?",
    answer:
      "MMI supports prototype builds through mass production by aligning tooling, manufacturing processes, inspection, and sub-assembly planning from the start.",
  },
  {
    question: "How do I request a quote?",
    answer:
      "Simply fill out the inquiry form above with your project details and CAD files, or contact us directly via phone or email for immediate assistance.",
  },
  {
    question: "Is there a minimum order quantity?",
    answer:
      "No, we have no minimum order quantity. Whether you need a single prototype or thousands of parts, we can accommodate your requirements.",
  },
  {
    question: "Do you support prototype and production runs?",
    answer:
      "Yes, we support both small-scale prototyping and large production runs, offering flexibility to meet your project needs at any scale.",
  },
];

export default function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="flex flex-col"
    >
      {faqs.map((faq, index) => (
        <div key={index} className="border-b border-gray-200">
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="flex w-full items-center justify-between py-4 md:py-5 text-left transition-colors hover:text-gray-600"
          >
            <span className="text-[15px] md:text-base font-normal text-black">
              {faq.question}
            </span>
            <ChevronDown
              className={`h-5 w-5 flex-shrink-0 text-black transition-transform duration-200 ${
                openIndex === index ? "rotate-180" : ""
              }`}
            />
          </button>

          {openIndex === index && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="overflow-hidden"
            >
              <p className="pb-4 md:pb-5 text-[13.5px] md:text-sm leading-relaxed text-gray-600">
                {faq.answer}
              </p>
            </motion.div>
          )}
        </div>
      ))}
    </motion.div>
  );
}
